<div class="body">
  <div class="form-wrapper">
    <div class="form-content">
      <div class="form-section">
        <div [formGroup]="form" class="form-section-body">
          <div *ngIf="isGlobalSystemEventsReady" class="form-row">
            <mat-form-field class="custom-mat-form-field size size1of1">
              <mat-label>Choose the Event to notify</mat-label>
              <mat-select formControlName="systemEventId" class="custom-mat-select">
                <mat-option *ngFor="let systemEvent of collectionOfGlobalSystemEvents" [value]="systemEvent.id + ''" [disabled]="systemEvent.status == 'disabled'" class="custom-mat-option">{{systemEvent.displayName}}</mat-option>
              </mat-select>
              <mat-error><error-messages [control]="form.get('systemEventId')"></error-messages></mat-error>
            </mat-form-field>
          </div>

          <!-- skeleton -->
          <div *ngIf="!isGlobalSystemEventsReady" class="form-row">
            <mat-form-field class="custom-mat-form-field size size1of1">
              <input matInput disabled>
              <skeleton-loader [theme]="{'width': '40%'}"></skeleton-loader>
            </mat-form-field>
          </div>

          <div *ngIf="isGlobalChannelsReady" class="form-row">
            <div class="helper-text">Send a(n)</div><mat-form-field class="custom-mat-form-field size size1of1">
              <mat-label>Choose Channel</mat-label>
              <mat-select formControlName="channelId" class="custom-mat-select" (selectionChange)="onSelectChannel($event.value)">
                <ng-container *ngFor="let channel of collectionOfGlobalChannels" >
                  <mat-option  *appRestriction="channel.id === 5 ? 'feature_inbox_notifications|enabled|SCOPE_HIDE': ''" [value]="channel.id + ''" [disabled]="channel.status == 'disabled'" class="custom-mat-option">{{channel.displayName}}</mat-option>
              </ng-container>
              </mat-select>
              <mat-error><error-messages [control]="form.get('channelId')"></error-messages></mat-error>
            </mat-form-field>
            <div class="helper-text">notification</div>
          </div>

          <!-- skeleton -->
          <div *ngIf="!isGlobalChannelsReady" class="form-row">
            <mat-form-field class="custom-mat-form-field size size1of1">
              <input matInput disabled>
              <skeleton-loader [theme]="{'width': '40%'}"></skeleton-loader>
            </mat-form-field>
          </div>

          <div *ngIf="hasCompanyIntegration && isCompanyIntegrationsReady" class="form-row">
            <div class="helper-text">From </div>
            <mat-form-field *ngIf="this.collectionOfCompanyIntegrations.length > 0" class="custom-mat-form-field size size1of1">
              <mat-label>Choose Active Integration</mat-label>
              <mat-select formControlName="companyIntegrationId" class="custom-mat-select">
                <mat-option *ngFor="let companyIntegration of collectionOfCompanyIntegrations" [value]="companyIntegration.id + ''" class="custom-mat-option">{{companyIntegration.displayName}}</mat-option>
              </mat-select>
              <mat-error><error-messages [control]="form.get('companyIntegrationId')"></error-messages></mat-error>
            </mat-form-field>
            <section *ngIf="this.collectionOfCompanyIntegrations.length == 0" class="message message-row" style="width: 100%;">
              <div class="message-wrapper info">
                <div class="message-inner">
                  <mat-icon svgIcon="ico-help-faq" class="custom-mat-icon ico-size ico-xs"></mat-icon>
                  <p class="label-message-detail">Please choose another channel that has integrations.</p>
                </div>
              </div>
            </section>
          </div>

          <!-- skeleton -->
          <div *ngIf="hasCompanyIntegration && !isCompanyIntegrationsReady" class="form-row">
            <mat-form-field class="custom-mat-form-field size size1of1">
              <input matInput disabled>
              <skeleton-loader [theme]="{'width': '40%'}"></skeleton-loader>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

